import { Builder } from '@builder.io/sdk';
import { Table } from './Table';

Builder.registerComponent(Table, {
  name: 'Table',
  inputs: [
    {
      name: 'rows',
      type: 'list',
      subFields: [
        {
          name: 'column',
          type: 'list',
          subFields: [
            {
              name: 'cell',
              type: 'richText',
            },
          ],
        },
      ],
    },
  ],
});
